<div class='left-menu'>
  <ul class='nav navbar-nav'>
    <li [routerLinkActive]="['link-active']">
      <a class='menu-callback' (click)="onReload.emit()" title="Refresh">
        <span class='glyphicon glyphicon-refresh'></span> Refresh
      </a>
    </li>
    <li [routerLinkActive]="['link-active']">
      <a class='menu-callback' target="_blank" (click)="openDocumentationModal()" title="Wiki">
        <span class='glyphicon glyphicon-info-sign'></span> Documentation
      </a>
    </li>
    <li class="separator"></li>
    <li class="submenu-title">
      <h4>Excel</h4>
    </li>
    <li [routerLinkActive]="['link-active']">
      <a class='menu-callback' target="_blank" (click)="outputDownload.emit()" title="Dowload">
        <span class='glyphicon glyphicon-download'></span> Download
      </a>
    </li>
    @if (!defaults.isReadonlyUser) {
      <li [routerLinkActive]="['link-active']">
        <a class='menu-callback' title="Upload" (click)="onUpload()">
          <span class='glyphicon glyphicon-upload'></span> Upload
        </a>
      </li>
    }
    @if (!defaults.isReadonlyUser) {
      <li class="separator" [ngClass]="saveService.classSaveButton"></li>
    }
    @if (!defaults.isReadonlyUser) {
      <li [routerLinkActive]="['link-active']" [ngClass]="saveService.classSaveButton">
        <a class='menu-callback' (click)="saveService.fireSave()" title="Save">
          <span class='glyphicon glyphicon-floppy-disk'></span> Save
        </a>
      </li>
    }
  </ul>
</div>